import * as AT from '../../components/container/attributes';
import BaseModel from './BaseModel';

export default class IdentifierScheme extends BaseModel {
  constructor({id, countryId, designation, icd = undefined, active = true}) {
    super(id, '', designation);
    this.countryId = countryId;
    this.icd = icd;
    this.active = active;
  }

  get fullDesignation() {
    return `${this.id} - ${this.designation}`;
  }

  static get config() {
    const config = BaseModel.config;
    config['addable'] = false;
    return config;
  }
  get config() {
    return IdentifierScheme.config;
  }

  static get orderKey() {
    return 'id';
  }

  static get fkName() {
    return 'scheme_id';
  }
  static get apiRoute() {
    return 'identifier_scheme';
  }
  static get detailPageRoute() {
    return 'Configuration';
  }
  static get listPageRoute() {
    return 'Configuration';
  }
  get fkName() {
    return IdentifierScheme.fkName;
  }
  get apiRoute() {
    return IdentifierScheme.apiRoute;
  }
  get listPageRoute() {
    return IdentifierScheme.listPageRoute;
  }
  get detailPageRoute() {
    return IdentifierScheme.detailPageRoute;
  }

  static get browserDisplayAttrs() {
    return this.getAttributes(['designation']);
  }

  static get joinAttrsKey() {
    return ['countryId', 'designation'];
  }

  static get allAttributes() {
    return [
      new AT.StringAttribute({
        name: 'countryId',
        column: 'country_id',
        tableProperties: {
          header: 'hit-base.common.country',
          maxWidth: '1fr',
        },
      }),
      this.DESIGNATION_ATTRIBUTE(),
      new AT.StringAttribute({
        name: 'icd',
        tableProperties: {
          header: 'ICD',
          maxWidth: '1fr',
        },
      }),
    ];
  }
}
